import {Injectable} from '@angular/core';
import {areaFLLPsiTotalAw, UgAgPsiTotal} from '../interfaces';
import {CurrentSystemService} from './currentSystem.service';
import {productValuesType, louvreArea, area, areaFLL, areaFLLPsi} from "../interfaces";
import {fllUw} from "../constants";

@Injectable()
export class UwService {
	currentSystem = '';
	pv: productValuesType;
	area: area;
	areaFLLPsi: areaFLLPsi = {profileTopPsi: null, louvreShockPsi: null, profileBottomPsi: null, profileSidePsi: null, middleMullionPsi: null};
	areaFLL: areaFLL = fllUw;
	areaFLLPsiTotalAw: areaFLLPsiTotalAw;
	UgAgPsiTotal: UgAgPsiTotal;
	louvreArea: louvreArea;

	constructor(private currentSystemService: CurrentSystemService) { }

	/**
	 * set current system and default values for current system
	 */
	setCurrentSystem() {
		this.currentSystem = this.currentSystemService.getCurrentSystem();
		this.pv = this.currentSystemService.getCurrentPvs();
		//console.log(this.currentSystem, this.pv);
	}

	/**
	 * get uw value
	 * @param isolation
	 */
	getUwValue(isolation: boolean){
		if (this.currentSystem === 'FLL') {
			return isolation ? (this.areaFLLPsiTotalAw.awUp.withIso + this.areaFLLPsiTotalAw.total.withIso ) / this.louvreArea.aw :
				(this.areaFLLPsiTotalAw.awUp.noIso + this.areaFLLPsiTotalAw.total.noIso ) / this.louvreArea.aw ;
		}
		return isolation ? (this.UgAgPsiTotal.ugTimesAg + this.UgAgPsiTotal.piTimesLg + this.UgAgPsiTotal.totalUfAfWithIso) / this.louvreArea.aw :
			(this.UgAgPsiTotal.ugTimesAg + this.UgAgPsiTotal.piTimesLg + this.UgAgPsiTotal.totalUfAf) / this.louvreArea.aw;
	}

	/**
	 * calculate total ug and psi
	 * @param ug
	 * @param psi
	 */
	calculateUgPsiTotal(ug: number, psi: number) {
		return this.UgAgPsiTotal = {
			ugTimesAg: this.louvreArea.ag * ug,
			piTimesLg: this.louvreArea.lg * psi,
			totalUfAf: this.area.uf.noIsolation.top + this.area.uf.noIsolation.bottom + this.area.uf.noIsolation.side + this.area.uf.noIsolation.louvre,
			totalUfAfWithIso: this.area.uf.isolation.top + this.area.uf.isolation.bottom + this.area.uf.isolation.side + this.area.uf.isolation.louvre,
		}
	}

	/**
	 * calculate louvre areas
	 * @param width
	 * @param height
	 * @param louvreCount
	 * @param louvreHeight
	 * @param ug
	 * @param psi
	 * @param mm
	 */
	calculateLouvreAreas(width: number, height: number, louvreCount: number, louvreHeight: number, ug: number, psi: number, mm: boolean): louvreArea {
		// console.log(width, height, louvreCount, louvreHeight, ug, psi);
		const aw = this.calcAw(width, height);
		const af = this.calcAf();
		const louvreWidth = this.calculateLouvreWidth(width, mm);
		return this.louvreArea = {
			aw: aw,
			af: af,
			ag: aw - af,
			lg: this.calcLg(width, height, louvreCount, mm, louvreHeight),
			louvreArea: this.calcLouvreArea(louvreWidth, louvreHeight, width)
		}
	}

	calculateAreaFLL(width: number, height: number, nrLouvre: number, mm: boolean): areaFLLPsiTotalAw {

		this.areaFLLPsi = {
			profileTopPsi: {
				noIso: width / 1000 * this.areaFLL.profileTop.noIso,
				withIso: width / 1000 * this.areaFLL.profileTop.withIso
			},
			louvreShockPsi: {
				noIso: (width / 1000 * this.areaFLL.louvreShock.noIso) * (mm ? nrLouvre / 2 - 1 : nrLouvre - 1),
				withIso: (width / 1000 * this.areaFLL.louvreShock.withIso) * (mm ? nrLouvre / 2 - 1 : nrLouvre - 1)
			},
			profileBottomPsi: {
				noIso: width / 1000 * this.areaFLL.profileBottom.noIso,
				withIso: width / 1000 * this.areaFLL.profileBottom.withIso
			},
			profileSidePsi: {
				noIso: height / 1000 * this.areaFLL.profileSide.noIso * 2,
				withIso: height / 1000 * this.areaFLL.profileSide.withIso * 2
			},
			middleMullionPsi: {
				noIso: height / 1000 * this.areaFLL.middleMullion.noIso,
				withIso: height / 1000 * this.areaFLL.middleMullion.withIso
			}
		};

		console.log('areaFLLPsi',this.areaFLLPsi);

		return this.areaFLLPsiTotalAw = {
			total: {
				noIso: this.areaFLLPsi.profileTopPsi.noIso + this.areaFLLPsi.louvreShockPsi.noIso + this.areaFLLPsi.profileBottomPsi.noIso
					+ this.areaFLLPsi.profileSidePsi.noIso,
					// TODO add middle mullion again? answer until now NO
					// + this.areaFLLPsi.middleMullionPsi.noIso,
				withIso: this.areaFLLPsi.profileTopPsi.withIso + this.areaFLLPsi.louvreShockPsi.withIso + this.areaFLLPsi.profileBottomPsi.withIso
					+ this.areaFLLPsi.profileSidePsi.withIso
					// TODO add middle mullion again? answer until now NO
					// + this.areaFLLPsi.middleMullionPsi.withIso
			},
			awUp: {
				noIso: this.louvreArea.aw * this.pv.louvre.W_m2K,
				withIso:  this.louvreArea.aw * this.pv.louvre.W_m2K_iso
			}
		};
	}

	/**
	 * calculate louvre area
	 * @param width
	 * @param height
	 * @param nrLouvre
	 * @param psi
	 * @param middleMullion
	 */
	calcArea(width: number, height: number, nrLouvre: number, psi: number, middleMullion: boolean){
		const mm = middleMullion ? 1 : 0;
		const top = this.calcAreaTop(width);
		const bottom = this.calcAreaBottom(width);
		const sideNoTop = this.calcAreaSide(height).sideNoTop;
		const sideNoBottom = this.calcAreaSide(height).sideNoBottom;
		const louvre = this.calcAreaLouvre(width, nrLouvre, mm).louvre;
		const louvreAll = this.calcAreaLouvre(width, nrLouvre, mm).louvreAll;
		return this.area = {
			top: top,
			bottom: bottom,
			sideNoTop: sideNoTop,
			sideNoBottom: sideNoBottom,
			louvre: louvre,
			louvreAll:louvreAll,
			uf: {
				noIsolation: {
					top: top * this.pv.edgeTop.W_m2K,
					bottom: bottom * this.pv.edgeBottom.W_m2K,
					side: sideNoBottom * this.pv.edgeSide.W_m2K,
					louvre: louvreAll * this.pv.louvre.W_m2K
				},
				isolation: {
					top: top * this.pv.edgeTop.W_m2K_iso,
					bottom: bottom * this.pv.edgeBottom.W_m2K_iso,
					side: sideNoBottom * this.pv.edgeSide.W_m2K_iso,
					louvre: louvreAll * this.pv.louvre.W_m2K_iso
				}
			}
		};
	}

	/**
	 * calculate louvre width
	 * @param width
	 * @param middleMullion
	 */
	calculateLouvreWidth(width, middleMullion) {
		let glassWidth = this.calculateGlassWidth(width, middleMullion);

		if (this.currentSystem === ('FLM' || 'FLL')) {
			return glassWidth;
		}

		if (this.currentSystem === ('FLW24' || 'FLW28')) {
			if (middleMullion) {
				return ((glassWidth + this.pv.allowance.width - this.pv.dimensionsOpenLouvre.mm) / 2);
			} else {
				return (glassWidth + this.pv.allowance.width);
			}
		}
		return glassWidth + this.pv.allowance.width;
	}

	/**
	 * calculate Lg
	 * @param width
	 * @param height
	 * @param louvreCount
	 * @param middleMullion
	 * @param louvreHeight
	 */
	private calcLg (width: number, height: number, louvreCount: number, middleMullion: boolean, louvreHeight: number) {

		const nrLouvres = middleMullion ? louvreCount / 2 : louvreCount;

		if (this.currentSystem === ('FLM')) {
			// =(((D6/1000-Tabelle1!E23/1000-Tabelle1!E23/1000)*2)+(((D8/1000-Tabelle1!C23/1000-Tabelle1!G23/1000-(D10-1)*(Tabelle1!I23/1000))/D10)*2))*D10
			// debugger;
			return ((((width/1000 - this.pv.edgeSide.width/1000 - this.pv.edgeSide.width/1000) * 2) + (((height/1000 - this.pv.edgeTop.width/1000 - this.pv.edgeBottom.width/1000 - (nrLouvres - 1) * (this.pv.louvre.width/1000)) / nrLouvres) * 2)) * nrLouvres);
		}

		const glassWidth = this.calculateGlassWidth(width, middleMullion);
		const glassHeight = this.calculateGlassheight(louvreHeight);

		return 2 * (glassWidth + glassHeight) / 1000 * nrLouvres;
	}

	/**
	 * calculate louvre area
	 * @param louvreWidth
	 * @param louvreHeight
	 * @param width
	 */
	private calcLouvreArea(louvreWidth: number, louvreHeight: number, width: number) {
		return (width - 2 * this.pv.dimensionsOpenLouvre.sideMullion) / 1000 * (louvreHeight / 1000); 
	}

	/**
	 * calculate aw
	 * @param width
	 * @param height
	 */
	private calcAw(width: number, height: number) {
		return ( width / 1000 * height / 1000 );
	}

	private calcAf(){
		return this.area.top + this.area.bottom + this.area.sideNoBottom + this.area.louvreAll
	}

	/**
	 * calculate area top
	 * @param width
	 */
	private calcAreaTop(width: number){
		if (this.currentSystem === 'FLW28' || this.currentSystem === 'FLW24' || this.currentSystem === 'FLM' ) {
			return ((width / 1000) - ( 2 * this.pv.edgeSide.width ) / 1000) * ( this.pv.edgeTop.width / 1000);
		}
		if (this.currentSystem === 'FLW40' || this.currentSystem === 'FLW32') {
			return (width / 1000 ) * ( this.pv.edgeTop.width / 1000 );
		}
	}

	/**
	 * calculate area bottom
	 * @param width
	 */
	private calcAreaBottom(width: number){
		if (this.currentSystem === 'FLW28' || this.currentSystem === 'FLW24' || this.currentSystem === 'FLM') {
			return ((width / 1000 ) - ( 2 * this.pv.edgeSide.width ) / 1000 ) * ( this.pv.edgeBottom.width/ 1000 );
		}
		if (this.currentSystem === 'FLW40' || this.currentSystem === 'FLW32') {
			return width / 1000 * (this.pv.edgeBottom.width / 1000);
		}
	}

	/**
	 * calculate area side
	 * @param height
	 */
	private calcAreaSide(height: number){
		let sideNoTop;
		if (this.currentSystem === 'FLW28' || this.currentSystem === 'FLW24' || this.currentSystem === 'FLM') {
			sideNoTop = ( height / 1000 ) * ( this.pv.edgeSide.width / 1000 );
		}
		if (this.currentSystem === 'FLW40' || this.currentSystem === 'FLW32') {
			sideNoTop = (height - this.pv.edgeBottom.width - this.pv.edgeTop.width) / 1000 * (this.pv.edgeSide.width / 1000);
		}
		const sideNoBottom = sideNoTop * 2;
		return {sideNoTop, sideNoBottom}
	}

	/**
	 * calculate area louvre
	 * @param width
	 * @param nrLouvre
	 * @param mm
	 */
	private calcAreaLouvre(width: number, nrLouvre: number, mm: number) {
		let louvre;
		nrLouvre = mm ? nrLouvre / 2 : nrLouvre;
		
		if (this.currentSystem === 'FLW28' || this.currentSystem === 'FLW24' || this.currentSystem === 'FLM'){
			louvre = (width - this.pv.edgeSide.width - this.pv.edgeSide.width - ( mm * this.pv.middleMullion.width )) / 1000 * (this.pv.louvre.width / 1000 );
		} else {
			louvre = (width - this.pv.edgeSide.width - this.pv.edgeSide.width) / 1000 * (this.pv.louvre.width / 1000);
		}
		const louvreAll = louvre * (nrLouvre - 1);
		return {louvre, louvreAll}
	}

	/**
	 * calculate glass width
	 * @param width
	 * @param middleMullion
	 */
	private calculateGlassWidth(width, middleMullion) {
		if (this.currentSystem === ('FLM' || 'FLL' || 'FLW24')) {
			if (middleMullion) {
				return (width - 2 * ((this.pv.edgeWidth) + (this.pv.gabDimensions.side)));
			} else {
				return (width - 2 * ((this.pv.edgeWidth) + (this.pv.gabDimensions.side)) - this.pv.dimensionsOpenLouvre.mm / 2 );
			}
		}

		return width - 2 * (this.pv.edgeWidth + this.pv.gabDimensions.side) - this.pv.allowance.width - 20;
	}
	
	/**
	 * calculate glass height
	 * @param louvreHeight
	 */
	private calculateGlassheight(louvreHeight) {
		if (this.currentSystem === ('FLM' || 'FLL')) {
			return louvreHeight;
		}
		return louvreHeight - this.pv.allowance.height - 20
	}
}